import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { Category } from "../../categories.types";
import { requestUpdateCategory } from "./updateCategory.request";

const useUpdateCategory = (
  options?: MutationOptions<Category, ApiServiceError<ApiError>>
) => {
  return useMutation({
    mutationFn: requestUpdateCategory,
    ...options
  });
};

export default useUpdateCategory;
